var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"scrollable-container elevation-5"},[_c('v-card-title',{staticClass:"py-3"},[_c('div',[_vm._v("About VMS")])]),_c('v-card-text',{staticClass:"scrollable-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }